export default "__VITE_ASSET__CSOPUALE__"